import React from 'react';
import { IconComment, IconShare, IconLike } from '@xingternal/designkit';
import { withFlavour } from '@xingternal/flavour';

const xdlMapping = {
  IconSocialComment: IconComment,
  IconSocialShare: IconShare,
  IconSocialThumbsUp: IconLike,
};

export const withIconFlavour = Comp =>
  withFlavour(({ flavour, size, ...props }) => {
    props.width = props.width || size;
    props.height = props.height || size;
    props.size = size;
    const name = Comp.displayName;
    const SelectedIcon = flavour === 'xdl' ? xdlMapping[name] || Comp : Comp;
    return <SelectedIcon {...props} />;
  });
